import { CustomLabel, IStyleProps, theme } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";   

const { success, background, border, text } = theme.palette;

export const BoxWrapper = styled.div<IStyleProps>`
  height: 126px;
  width: 122px;
  background-color: ${(props) =>
    props?.active ? success.light : background.light};
  border: 1px solid ${(props) => (props?.active ? success.dark : border.dark)};
  border-radius: 10px;
  color: ${text.dark};
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  img {
    height: 60px;
    width: 60px;
  }
  ${CustomLabel} {
    font-size: 18px;
    font-weight: 600;
    margin-top: 7px;
    color: ${text.dark};
  }
  .item-locked {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 15px;
    height: 20px;
  }
`;
